import { render, staticRenderFns } from "./LearningUnitCardItem.vue?vue&type=template&id=04acb0ae&scoped=true&"
import script from "./LearningUnitCardItem.vue?vue&type=script&lang=js&"
export * from "./LearningUnitCardItem.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitCardItem.vue?vue&type=style&index=0&id=04acb0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04acb0ae",
  null
  
)

export default component.exports